export type Sex = "male" | "female" | "combined";
export type AgeBand = "all" | "20_39" | "40_59" | "60_plus";

export const CM_PER_IN = 2.54;
export const IN_PER_FT = 12;

export function cmToFeetInches(cm: number): { ft: number; inch: number } {
  const totalIn = cm / CM_PER_IN;
  const ft = Math.floor(totalIn / IN_PER_FT);
  const inch = Math.round((totalIn - ft * IN_PER_FT) * 10) / 10;
  return { ft, inch };
}

export function feetInchesToCm(ft: number, inch: number): number {
  const totalIn = ft * IN_PER_FT + inch;
  return Math.round(totalIn * CM_PER_IN * 10) / 10;
}

export function clampHeight(cm: number): number {
  return Math.max(135, Math.min(210, cm));
}
